import * as React from 'react';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import TextWrapper from 'bundles/unified-description-page-common/components/modules/key-information/util/TextWrapper';
import { useDurationLabels } from 'bundles/unified-description-page-common/hooks/useDurationLabels';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

type Props = {
  totalLearningMonths: number;
  learningHoursPerWeek: number;
};

export const KeyInformationSpecializationDurationAndSchedule = ({
  totalLearningMonths,
  learningHoursPerWeek,
}: Props) => {
  const intl = useIntl();
  const { enableXDPRedesignKIM } = useXDPRedesignPhase1Data();

  const labels = useDurationLabels(totalLearningMonths * learningHoursPerWeek * 4, true, learningHoursPerWeek) ?? {
    title: _t('Flexible schedule'),
    subtitle: intl.formatMessage(
      _t(
        '{totalMonths} {totalMonths, plural, =1 {month} other {months}}, {totalHours} {totalHours, plural, =1 {hour} other {hours}} a week'
      ),
      {
        totalMonths: totalLearningMonths,
        totalHours: learningHoursPerWeek,
      }
    ),
  };

  if (enableXDPRedesignKIM) {
    const title = labels.subtitle ? labels.subtitle : labels.title;
    const wrappedTitle = <TextWrapper>{title}</TextWrapper>;
    return <KeyInformationDetailsItem title={wrappedTitle} subtitle={labels.subtitle && <div>{labels.title}</div>} />;
  }

  return (
    <KeyInformationDetailsItem
      title={labels.title}
      subtitle={
        <>
          {labels.subtitle && <div>{labels.subtitle}</div>}
          <div>{_t('Learn at your own pace')}</div>
        </>
      }
    />
  );
};

export default KeyInformationSpecializationDurationAndSchedule;
